if (!customElements.get('product-upsell-popup')) {
  customElements.define(
    'product-upsell-popup',
    class ProductUpsellPopup extends HTMLElement {
      connectedCallback() {
        this.overlay = this.querySelector('.product-upsell-popup__overlay');
        this.closeButton = this.querySelector('.product-upsell-popup__close');

        this.storageKey = `product-upsell-popup-${this.dataset.productId}`;

        this.closeButton.addEventListener('click', () => this.close());
        this.overlay.addEventListener('click', (event) => {
          if (event.target === this.overlay) this.close();
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.close();
        });

        // Se algo for adicionado ao carrinho
        // o cliente já está comprando, não interrompemos mais com o popup de saída.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
            this.markAsShown();
            this.close();
          });
        }

        if (this.wasShown() || window.Shopify?.designMode) return;

        this.bindExitIntent();
      }

      wasShown() {
        try {
          return sessionStorage.getItem(this.storageKey) === 'true';
        } catch {
          return this.shown === true;
        }
      }

      markAsShown() {
        this.shown = true;
        sessionStorage.setItem(this.storageKey, 'true');
      }

      bindExitIntent() {
        const isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;

        if (!isTouch) {
          document.documentElement.addEventListener('mouseleave', (event) => {
            if (event.clientY <= 0) this.open();
          });
          return;
        }

        let backTrapArmed = false;
        const armBackTrap = () => {
          if (backTrapArmed || this.wasShown()) return;
          backTrapArmed = true;

          history.pushState({ productUpsellPopup: true }, '', window.location.href);
          window.addEventListener('popstate', () => {
            if (!this.wasShown()) this.open();
          });
        };
        window.addEventListener('touchstart', armBackTrap, { once: true, passive: true });
        window.addEventListener('scroll', armBackTrap, { once: true, passive: true });

        document.addEventListener(
          'click',
          (event) => {
            if (this.wasShown()) return;

            const link = event.target.closest('a[href]');
            if (!link || link.closest('product-upsell-popup, .product-upsell')) return;

            const href = link.getAttribute('href');
            if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

            // Links controlados por JS do tema (ex: ícone do carrinho abre o drawer)
            if (link.getAttribute('role') === 'button' || link.id === 'cart-icon-bubble') return;

            let url;
            try {
              url = new URL(link.href, window.location.href);
            } catch {
              return;
            }

            if (url.host === window.location.host && url.pathname === window.location.pathname) return;

            // Ir para o carrinho/checkout não é saída da loja
            if (url.pathname.startsWith('/cart') || url.pathname.startsWith('/checkout')) return;

            event.preventDefault();
            event.stopPropagation();
            this.open();
          },
          true
        );
      }

      open() {
        if (this.wasShown()) return;

        this.markAsShown();
        this.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        this.closeButton.focus();
      }

      close() {
        this.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }
  );
}
